export default `CGN25-XYZ
ABC01-OPQ
CGN20-AAA`;
